<template>
  <button
    type="button"
    class="block w-full px-2 border-b cursor-pointer hover:bg-theme-50 text-start"
    :class="[
      selected?.id == group.id ? 'border-l-4 border-l-theme-400 bg-theme-50' : 'bg-white',
      mode == 'view' ? 'py-3' : 'py-1',
    ]"
    @click="emit('select', group)">
    <BaseInput
      v-if="mode == 'edit'"
      v-model="modifiedGroupName"
      @keyup.enter="groupNameUpdate"
      @blur="groupNameUpdate"
      @click.stop />
    <p v-else class="text-sm tracking-wide text-theme-500">{{ group.name }}</p>
  </button>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import BaseInput from '../common/BaseInput.vue';
import type { Group } from '@/types/Groups';

const props = defineProps<{
  group: Group;
  selected?: Group;
  mode: 'view' | 'edit';
}>();

const emit = defineEmits(['select', 'update:group']);

const modifiedGroupName = ref(props.group.name);

watch(
  () => props.group.name,
  (newName) => {
    modifiedGroupName.value = newName;
  }
);

function groupNameUpdate() {
  emit('update:group', { ...props.group, name: modifiedGroupName.value });
}
</script>
